import { render, staticRenderFns } from "./bimRow.vue?vue&type=template&id=2ca601fc&scoped=true&"
import script from "./bimRow.vue?vue&type=script&lang=js&"
export * from "./bimRow.vue?vue&type=script&lang=js&"
import style0 from "./bimRow.vue?vue&type=style&index=0&id=2ca601fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca601fc",
  null
  
)

export default component.exports